import { ApiClient } from "../ApiClient";

const SPENDINGS_SUMMARY_ENDPOINT = "finances/spendings/summary";
const SPENDINGS_REVIEW_ENDPOINT = "finances/spendings/review";

/**
 * Base function for fetching spending analytics.
 * Now async to return parsed JSON data directly to components.
 */
export const getSpendingsSummary = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  const url = queryString
    ? `${SPENDINGS_SUMMARY_ENDPOINT}?${queryString}`
    : SPENDINGS_SUMMARY_ENDPOINT;

  const res = await ApiClient.get(url);
  return await res.json();
};

/**
 * The following functions now implicitly return Promises that resolve to JSON data
 */

export const getCurrentSpentChart = () =>
  getSpendingsSummary({ response_type: "current_spent_chart" });

export const getSpendingBreakdownDonuts = () =>
  getSpendingsSummary({ response_type: "breakdown_donuts" });

export const getSpendingHeavyHitters = () =>
  getSpendingsSummary({ response_type: "heavy_hitters" });

export const getSpendingHeavyHitterTransactions = (category) =>
  getSpendingsSummary({
    response_type: "heavy_hitter_transactions",
    categories: category,
  });

// ============================================================
// SPENDING USER DECISION REVIEW ENDPOINTS
// ============================================================

/**
 * Fetches transactions for the current month requiring spending review.
 */
export const getUnmarkedSpendingTransactions = async () => {
  const res = await ApiClient.get(SPENDINGS_REVIEW_ENDPOINT);
  return await res.json();
};

/**
 * Submits user decisions (Spending/No Spending) for a batch of transactions.
 */
export const bulkUpdateSpendingConfirmation = async (payload) => {
  const res = await ApiClient.post(SPENDINGS_REVIEW_ENDPOINT, payload);
  return await res.json();
};
